import { MeasurmentDate } from "../types/app.interfaces";
import { ProfileSettings } from "../types/app.storage.enums";
import { getObjectFromStorage } from "./storagehelper";
import { HoldingExclude } from "../types/app.enums";
import { ExcelDateToJSDate } from "../utils/common";
export function isValidEndDate(dateString: any): any {
  dateString = ExcelDateToJSDate(dateString);
  if (dateString == null) {
    return measurmentDateSearch().endDates;
  } else if (dateString == "") {
    return false;
  } else if (dateString.length < 4) {
    return false;
  } else {
    const chkDate = new Date(dateString);
    const splitDates = chkDate.toLocaleDateString().split("/");
    if (splitDates[0].length == 3 || splitDates[2].length < 4) {
      return false;
    }
    return dateString;
  }
}

export function isValidFilter(filter: any): any {
  if (filter != null) {
    return filter.toString();
  }
  return filter;
}

export function isValidBeginDate(dateString: string): any {
  dateString = ExcelDateToJSDate(dateString);
  if (dateString == null) {
    return measurmentDateSearch().startDates;
  } else if (dateString == "") {
    return false;
  } else if (dateString.length < 4) {
    return false;
  } else {
    const chkDate = new Date(dateString);
    const splitDates = chkDate.toLocaleDateString().split("/");
    if (splitDates[0].length == 3 || splitDates[2].length < 4) {
      return false;
    }
    return dateString;
  }
}

/*export function isValidSelectionId(setId: any) {
  let resSetId = "";
  if (setId == null || setId == "") {
    resSetId = "0";
  } else if (typeof setId === "string" || setId instanceof String) {
    if (setId.includes(",")) {
      resSetId = "-1";
    } else {
      const isVal = Number(setId).toString();
      resSetId = isVal === "NaN" ? "0" : isVal;
    }
  } else {
    resSetId = setId;
  }
  return resSetId;
}*/
export function isValidSelectionId(setId: any) {
  let selectionsetIdValue = "";

  try {
    if (setId == null || setId == "") {
      selectionsetIdValue = "0";
    } else if (typeof setId === "string" || setId instanceof String) {
      if (!setId.includes(",")) {
        const isVal = Number(setId).toString();
        selectionsetIdValue = isVal === "NaN" ? "-1" : isVal;
      } else {
        selectionsetIdValue = "-1";
      }
    } else if (Array.isArray(setId)) {
      selectionsetIdValue = "-1";
    } else if (typeof setId === "number") {
      selectionsetIdValue = setId.toString();
    } else {
      selectionsetIdValue = "Invalid";
    }
  } catch (error) {
    selectionsetIdValue = "-1";
  }

  return selectionsetIdValue;
}

export function getSingleOrRangeValues(id: any, filerparam?: any) {
  let investmentId: any;
  const sb = [];
  const len = id != null ? id.length : 0;
  let idValue;
  if (len == 1) {
    if (!isNaN(id[0])) idValue = Number(id[0]);
    else idValue = id[0].toString();

    if (idValue.toString().toUpperCase() == "ALL") {
      investmentId = id.toString();
    } else if (typeof idValue === typeof String()) {
      if (
        (idValue.trim().toUpperCase() !== "FILTER" && !idValue.includes(",") && !/^\d+$/.test(idValue)) ||
        (filerparam === undefined && idValue === "")
      ) {
        investmentId = "Error" + "Invalid format for ID parameter";
        investmentId = "-1";
      } else if (filerparam === undefined && idValue !== "Filter") {
        investmentId = idValue;
      } else if (idValue.toUpperCase() === "FILTER" && (filerparam === null || filerparam === undefined)) {
        investmentId = "-1";
        investmentId = "Error Filter parameter not specified.";
      } else if (idValue.toString.toUpperCase != "FILTER" && (String(filerparam) == "" || filerparam == null)) {
        investmentId = "-1";
      } else if (String(filerparam) != "" && filerparam != null && idValue.toString.toUpperCase == "FILTER") {
        investmentId = "-1";
      } else if (String(idValue).includes(",") == false) {
        idValue = Number(idValue);
        id = String(idValue);
      } else {
        investmentId = id;
      }
    } else if (typeof idValue === typeof Number()) {
      if (
        (filerparam === undefined || filerparam === null || filerparam === "") &&
        idValue.toString().toUpperCase() !== "FILTER"
      ) {
        investmentId = idValue.toString();
      } else if (filerparam !== "" && idValue.toString().toUpperCase() !== "FILTER") {
        investmentId = idValue.toString();
      } else {
        return "-1";
      }
    }
  } else if (typeof id == typeof {}) {
    if (id != null) {
      const array: any[][] = id as any[][];
      const rows: number = array.length;
      const cols: number = array[0].length;
      for (let x = 0; x < rows; x++) {
        for (let y = 0; y < cols; y++) {
          if (typeof array[x][y] === "number") {
            sb.push(array[x][y]);
          }
        }
      }
      if (sb != null && sb.length > 0) {
        investmentId = sb.toString().trimEnd();
        investmentId = investmentId.split('"').join("");
      } else if (String(investmentId) == "" || investmentId == null) {
        investmentId = "Error" + "Invalid format for ID parameter";
        return "-1";
      }
    } else investmentId = "-1";
  } else if (id == null || id == "" || filerparam != null) {
    investmentId = "-1";
  }
  return investmentId;
}

export function isBurgissManagedClient(indexId: any) {
  let isBurgissManaged: any;

  if (indexId == "" || indexId == null) {
    isBurgissManaged = null;
  } else if (indexId instanceof String || Number(indexId)) {
    isBurgissManaged = JSON.parse(window.localStorage.getItem("dataPME")).filter((x) => x.benchmarkID == indexId)[0]
      .burgissManaged;
  }
  return isBurgissManaged;
}

export function isValidDate(dateString: string): any {
  dateString = ExcelDateToJSDate(dateString);
  if (dateString == "" || dateString == null) {
    const chkDate = new Date();
    return chkDate;
  } else if (dateString.length < 4) {
    return false;
  } else {
    const chkDate = new Date(dateString);
    if (chkDate.toLocaleDateString() == "Invalid Date") return false;
    const splitdates = chkDate.toLocaleDateString().split("/");
    if (splitdates[0].length == 3 || splitdates[2].length < 4) {
      return false;
    }
    return dateString;
  }
}

export function isValidPercentRankValue(value: any, decount?: any): any {
  let resValue: any;

  if (value == "" || value == null) {
    resValue = "0";
  } else if (!Number(value)) {
    resValue = "-1";
  } else {
    if (decount == 2) {
      if (decimalPlaces(value) > 2) {
        resValue = value.toFixed(2);
      } else {
        resValue = value;
      }
    } else {
      if (decimalPlaces(value) > 4) {
        resValue = value.toFixed(4);
      } else {
        resValue = value;
      }
    }
  }
  return resValue;
}

export function decimalPlaces(num: any) {
  const match = ("" + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  if (!match) {
    return 0;
  }
  return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
}

/*export function isBaseorlocalcurrency(currency: string): string {
  if (currency == null || currency == "") {
    return "true";
  } else {
    if (currency.toUpperCase() == "Base".toUpperCase()) {
      return "true";
    } else if (currency.toUpperCase() == "Local".toUpperCase()) {
      return "false";
    } else {
      return "InValid";
    }
  }
}*/

export function validateAlternateBaseCurrencyCode(currencyCode: string) {
  let currencyResult: any = null;
  try {
    if (currencyCode != null) {
      const dtAlternateBaseCurrencies: any = getObjectFromStorage<any>(ProfileSettings.DtAlrternateBaseCurrencies);
      currencyResult = dtAlternateBaseCurrencies.filter(
        (a: any) => a.code.toString().toUpperCase() == currencyCode.toString().toUpperCase().trim()
      );
    }
    if (currencyCode == "" || currencyCode == null) {
      return "";
    } else if (currencyCode.toUpperCase() == "LOCAL" || currencyCode.toUpperCase() == "BASE") {
      return "";
    } else if (currencyResult.length > 0) {
      return currencyResult[0]["code"];
    } else {
      return "InvError #NOTFOUND - Alternate Base Currency specified not found";
    }
  } catch (e) {
    return "InvError #NOTFOUND - Alternate Base Currency specified not found";
  }
}

export function isValidCurrency(currency: any) {
  let result = null;
  if (currency != null && currency != "") {
    const curr = getObjectFromStorage<any>("currency");
    for (let i = 0; i < curr.length; i++) {
      if (curr[i].code.toString().toUpperCase() === currency.toUpperCase()) {
        return curr[i].code.toString();
      } else {
        result = "-1";
      }
    }
  }
  return result;
}

export function validPremiumRange(premium: number, min: number, max: number) {
  let result: any;
  if (premium == 0) {
    result = "";
  } else if (premium >= min && premium <= max) {
    result = 1;
  } else {
    result = 0;
  }
  return result;
}

export function returnConstituentCount(isReturnConst: any): any {
  if (isReturnConst == "" || isReturnConst == null) {
    return false;
  } else if (typeof isReturnConst === "boolean") {
    return isReturnConst;
  } else if (
    isReturnConst.toString().toLowerCase().includes("true") ||
    isReturnConst.toString().toLowerCase().includes("false")
  ) {
    return isReturnConst;
  } else {
    return "-1";
  }
}

export function validRFParam(rollForward: string): any {
  if (rollForward == "" || rollForward == null) {
    return true;
  } else if (rollForward.toString().toUpperCase() == "TRUE") {
    return false;
  } else if (rollForward.toString().toUpperCase() == "FALSE") {
    return true;
  } else {
    return "Invalid";
  }
}

export function validIndexId(index: string): any {
  let indexId;
  if (index == "" || index == null) {
    indexId = "";
  } else {
    indexId = parseFloat(index);
  }
  return indexId;
}

export function validPremiumValue(premium: string): any {
  let premiumId;
  if (premium == "" || premium == null) {
    premiumId = "";
  } else {
    premiumId = parseFloat(premium);
  }
  return premiumId;
}

export function getIdType(idType: string, restrictType?: string): string {
  let typeResult = "";

  const value = idType != null ? String(idType).trim().toUpperCase() : null;
  if (value == "INVESTOR" && restrictType == "PooledBenchmarkCalc") {
    return "Invalid";
  }
  switch (value) {
    case null:
      typeResult = "i";
      break;
    case "PORTFOLIO":
      typeResult = "p";
      break;
    case "INVESTMENT":
      typeResult = "i";
      break;
    case "INVESTOR":
      typeResult = "a";
      break;
    default:
      typeResult = "404";
      break;
  }
  return typeResult;
}

export function dateCompare(stDate: string, enDate: string): boolean {
  if (stDate == null) {
    return true;
  }
  if (new Date(stDate) < new Date(enDate)) {
    return true;
  } else {
    return false;
  }
}

export function isValidPercentile(value: any): any {
  let resValue: any;
  const percentileValues: number[] = [0.05, 0.25, 0.5, 0.75, 0.95];
  if (value == "" || value == null) {
    resValue = "0";
  } else if (percentileValues.includes(value)) {
    resValue = value;
  } else {
    resValue = "-1";
  }
  return resValue;
}

export function isValidYear(year: any): any {
  let resValue: any;
  if (year == "" || year == null) {
    resValue = "0";
  } else if (year < 1 || year > 15) {
    resValue = "-1";
  } else {
    resValue = year;
  }
  return resValue;
}

export function validDynamicParameter(dynamicParameter?: string): any {
  if (String(dynamicParameter) == "" || dynamicParameter == null) {
    return "";
  }
  const attArr: any[] = dynamicParameter.split(";");
  const arrList: any[] = [];
  if (attArr.length > 1) {
    for (let i = 0; i < attArr.length; i++) {
      const arrObj = attArr[i];
      const titleArr = arrObj.split("=");
      if (titleArr.length > 1) {
        const attTitle = titleArr[0];

        if (arrList.includes(attTitle.toUpperCase.toString().trim) == true) {
          return "Error_" + attTitle;
        }

        arrList.push(attTitle.toUpperCase.toString().trim);
      } else {
        return "";
      }
    }
  }
}

export function validateCurrencySetVal(sheetAlias: string) {
  let msg = "";
  let shCurHegeFlag: any = getObjectFromStorage<any>(ProfileSettings.CurrencyHedgeList);
  shCurHegeFlag = shCurHegeFlag.filter((x) => x.sheetName.trim().toLowerCase() == sheetAlias.trim().toLowerCase())[0]
    .flag_CurrencyNeutral;

  const shCurHegeVal: string = getObjectFromStorage<any>(ProfileSettings.CurrencyHedgeList).filter(
    (x) => x.sheetName.trim().toLowerCase() == sheetAlias.trim().toLowerCase()
  )[0].ddl_curSetValue;

  msg = shCurHegeVal == "-1" ? "" : shCurHegeVal;

  if (shCurHegeFlag) {
    if (shCurHegeVal == "-1" || shCurHegeVal == "" || shCurHegeVal != null) {
      msg = "#Error - The currency neutral set does not exist.";
    }
  }

  return msg;
}

export function validHorizonQuarter(horqtz: any): any {
  let horqtzres = "1";
  try {
    if (horqtz == null) {
      return horqtzres;
    }
    let res = 0;
    if (horqtz % 1 !== 0) {
      horqtzres = "Error Invalid Format HorizonQuarters";
      return horqtzres;
    } else {
      res = Number(horqtz);
    }
    if (res >= 1 && res <= 8) {
      horqtzres = res.toString();
    } else {
      horqtzres = "Error Invalid Input Horizon Qtrs";
      return horqtzres;
    }
  } catch (e) {
    horqtzres = "Error Invalid Input Horizon Qtrs";
  }

  return horqtzres;
}

export function valNumsimulationRank(numsimulation: any): any {
  let numsim = null;
  let res = 0;
  if (numsimulation == "" || numsimulation == null) {
    return null;
  }
  if (numsimulation % 1 != 0) {
    numsim = "Error Invalid Format Num Simulations";
    return "-1";
  } else {
    res = Number(numsimulation);
  }

  if (res >= 100 && res <= 10000) {
    numsim = String(res);
    return numsim;
  } else {
    return "-1";
  }
}
export function valDesiredSampleSize(dessamsize: any): any {
  let dessampsiz = 5;
  if (dessamsize == "" || dessamsize == null) {
    return dessampsiz;
  }
  let res = 0;
  res = Number(dessamsize);
  if (res <= 0) {
    return "-1";
  } else {
    dessampsiz = res;
    return dessampsiz;
  }
}
export function valStopOnRank(stopOn: any): any {
  const resstoponlist = new Set(["WARNING", "ERROR"]);
  let resstopon = "WARNING";
  if (stopOn == "" || stopOn == null) {
    return resstopon;
  }
  if (resstoponlist.has(stopOn.toString().toUpperCase()) == true) {
    resstopon = String(stopOn);
    return resstopon;
  } else {
    return "-1";
  }
}

export function valSampleStatisticsForRankValueTwoDecimal(rankValue: any): any {
  if (rankValue == "" || rankValue == null) {
    return "";
  } else if (isNumber(rankValue)) {
    let arr: any[];
    // eslint-disable-next-line prefer-const
    arr = String(rankValue).split(".");
    if (arr.length >= 2) {
      if (arr[1].length > 4) {
        return -1;
      }
    }
    return rankValue;
  } else {
    return -1;
  }
}
export function isNumber(value: any): any {
  return typeof value === "number";
}
export function valMinSampleSize(minsampsize?: any): any {
  // const minsize = 1;
  // eslint-disable-next-line no-cond-assign
  if (minsampsize == "" || minsampsize == null) {
    return null;
  }
  let res = 0;
  res = Number(minsampsize);
  if (res <= 0) {
    return "-1";
  } else {
    minsampsize = res;
    return minsampsize;
  }
}

export function valHorizonQuarters(horqtz?: any): any {
  const horqtzres = 1;
  let res = 0;
  res = Number(horqtz);
  // eslint-disable-next-line no-cond-assign
  if (horqtz == "" || horqtz == null) {
    return horqtzres;
  }
  if (res >= 1 && res <= 8) {
    return res;
  } else {
    return "-1";
  }
}

export function valMaxdroppedperiodact(maxdroperiodact?: any): any {
  let mpdact = 0.5;
  // eslint-disable-next-line no-cond-assign
  if (maxdroperiodact == "" || maxdroperiodact == null) {
    return mpdact;
  }
  let res = 0;
  res = Number.parseFloat(maxdroperiodact);
  if (res > 1 || res < 0) {
    return "-1";
  } else {
    mpdact = res;
    return mpdact;
  }
}

export function valBMUHistoricalWindowLengthQtrs(bmuhistoricalwindowlengthqtrs?: any): any {
  const bmuhwlo = 40;
  // eslint-disable-next-line no-cond-assign
  if (bmuhistoricalwindowlengthqtrs == "" || bmuhistoricalwindowlengthqtrs == null) {
    return bmuhwlo;
  }
  let res = 0;
  if (bmuhistoricalwindowlengthqtrs % 1 != 0) {
    return -1;
  } else {
    res = Number(bmuhistoricalwindowlengthqtrs);
  }
  if (res < 1) {
    return -1;
  } else {
    return res;
  }
}
export function valMaxAgeDiffYears(maxagediffyear?: any): any {
  const maxagediff = 0.25;
  // eslint-disable-next-line no-cond-assign
  if (maxagediffyear == "" || maxagediffyear == null) {
    return maxagediff;
  }
  let res = 0;
  res = Number.parseFloat(maxagediffyear);
  if (res < 0) {
    return "-1";
  } else {
    return res;
  }
}

export function validateReportedValuationRank(requirereportedvaluation?: any): any {
  let result = 0;
  const validate = 100;
  // eslint-disable-next-line no-undef, no-unused-vars
  const value = String(requirereportedvaluation);
  if (value.trim().toUpperCase() == "STARTDATE") {
    result = validate;
  } else if (value.trim().toUpperCase() == "ENDDATE") {
    result = 2;
  } else if (value == "STARTANDENDDATE") {
    result = validate;
  } else if (value.trim().toUpperCase() == "" || value == "null" || value == null) {
    result = 0;
  } else {
    result = validate;
  }

  return result;
}

export function validNumsimulation(numsimulation: any): any {
  let numsim = "1000";

  try {
    if (numsimulation == null) {
      return numsim;
    }

    let res = 0;

    if (numsimulation % 1 !== 0) {
      numsim = "Error Invalid Format Num Simulations";
      return numsim;
    } else {
      res = Number(numsimulation);
    }

    if (res >= 100 && res <= 10000) {
      numsim = res.toString();
    } else {
      numsim = "Error Invalid Input Num Simulations";
      return numsim;
    }
  } catch (e) {
    numsim = "Error Invalid Input Num Simulations";
  }

  return numsim;
}

export function validDesiredSampleSize(dessamsize: any): any {
  let dessampsiz = "5";

  try {
    if (dessamsize == null) {
      return dessampsiz;
    }

    let res = 0;

    if (dessamsize % 1 !== 0) {
      dessampsiz = "Error Invalid Format Desired Sample Size";
      return dessampsiz;
    } else {
      res = Number(dessamsize);
    }

    if (res <= 0) {
      dessampsiz = "Error Invalid Input Desired Sample Size";
      return dessampsiz;
    } else {
      dessampsiz = res.toString();
      return dessampsiz;
    }
  } catch (e) {
    dessampsiz = "Error Invalid Input Desired Sample Size";
  }

  return dessampsiz;
}

export function validMinsamplesize(minsampsize: any): any {
  let minsamplesize = "1";

  try {
    if (minsampsize == "" || minsampsize == null) {
      return minsamplesize;
    }

    let res = 0;

    if (minsampsize % 1 !== 0) {
      minsamplesize = "Error Invalid Format Min Sample Size";
      return minsamplesize;
    } else {
      res = Number(minsampsize);
    }

    if (res <= 0) {
      minsamplesize = "Error Invalid Input Min Sample Size";
      return minsamplesize;
    } else {
      minsamplesize = res.toString();
      return minsamplesize;
    }
  } catch (e) {
    minsamplesize = "Error Invalid Input Min Sample Size";
  }

  return minsamplesize;
}

export function validBMUHistoricalWindowLengthQtrs(historicalwindowlengthqtrs: any): any {
  let BMUHWLQ = "40";

  try {
    if (historicalwindowlengthqtrs == "" || historicalwindowlengthqtrs == null) {
      return BMUHWLQ;
    }

    let res = 0;

    if (historicalwindowlengthqtrs % 1 !== 0) {
      BMUHWLQ = "Error Invalid Format BMU Window Length Qtrs";
      return BMUHWLQ;
    } else {
      res = parseInt(historicalwindowlengthqtrs, 10);
    }

    if (res < 1) {
      BMUHWLQ = "Error Invalid Input BMU Window Length Qtrs";
      return BMUHWLQ;
    } else {
      BMUHWLQ = res.toString();
      return BMUHWLQ;
    }
  } catch (e) {
    BMUHWLQ = "Error Invalid Input BMU Window Length Qtrs";
  }

  return BMUHWLQ;
}

export function validMaxAgeDiffYears(maxagediffyears: any): any {
  let maxagediffyrs = "0.25";
  try {
    if (maxagediffyears == "" || maxagediffyears == null) return maxagediffyrs;

    // decimal
    const res: number = parseFloat(maxagediffyears.toFixed(2));
    if (res < 0) {
      maxagediffyrs = "Error Invalid Input Max Age Diff Years";
      return maxagediffyrs;
    } else {
      maxagediffyrs = res.toString();
      return maxagediffyrs;
    }
  } catch (e) {
    maxagediffyrs = "Error Invalid Input Max Age Diff Years";
  }
  return maxagediffyrs;
}

export function validStopOn(stopon: any): any {
  let resstopon = "WARNING";
  const lststopon: string[] = ["INFO", "WARNING", "ERROR"];
  if (stopon == "" || stopon == null) {
    return resstopon;
  } else if (lststopon.includes(stopon.toString().toUpperCase())) {
    resstopon = stopon.toString();
  } else {
    return "ErrorMessage Invalid Input Stop On";
  }

  return resstopon;
}

export function validateBaseLocalCurrencyParam(baseLocalCurrency: any, functionName = ""): string {
  let currencyResult: any = null;
  try {
    if (baseLocalCurrency != null) {
      const dtAlternateBaseCurrencies: any = getObjectFromStorage<any>(ProfileSettings.DtAlrternateBaseCurrencies);
      currencyResult = dtAlternateBaseCurrencies.filter(
        (a: any) => a.code.toString().toUpperCase() == baseLocalCurrency.toString().toUpperCase().trim()
      );
    }
    if (baseLocalCurrency == "" || baseLocalCurrency == null) {
      return "true";
    } else if (baseLocalCurrency.toString().toUpperCase() === "LOCAL".toUpperCase() && functionName !== "") {
      return "Invalid";
    } else if (baseLocalCurrency.toString().toUpperCase() === "BASE".toUpperCase()) {
      return "true";
    } else if (baseLocalCurrency.toString().toUpperCase() === "LOCAL".toUpperCase()) {
      return "false";
    } else if (currencyResult.length !== 0) {
      return "true";
    } else {
      return "Invalid";
    }
  } catch (error) {
    return "Invalid";
  }
}

export function validateAlternateFundSize(alternateFundSizeFlag: any): string {
  try {
    if (alternateFundSizeFlag == "" || alternateFundSizeFlag == null) {
      return "FALSE";
    } else if (typeof alternateFundSizeFlag === "boolean" && alternateFundSizeFlag) {
      return "TRUE";
    } else {
      return "FALSE";
    }
  } catch {
    return "FALSE";
  }
}

export function valSampleStatistics(samplestatic: any): any {
  let ressampsat = "PERCENTILE95";
  const lstsampstat: string[] = [
    "COUNT",
    "MEAN",
    "PERCENTILE5",
    "PERCENTILE25",
    "PERCENTILE50",
    "PERCENTILE75",
    "PERCENTILE90",
    "PERCENTILE95",
    "RANK",
  ];

  if (samplestatic == null || samplestatic == "") {
    return ressampsat;
  } else if (lstsampstat.includes(samplestatic.toString().toUpperCase())) {
    ressampsat = samplestatic.toString();
    return ressampsat;
  } else {
    return "Error Invalid Input Sample Statistic";
  }
}

export function valSampleStatisticsRank(samplestatic: any, ressampsat: string): any {
  const lstsampstat: string[] = [
    "COUNT",
    "MEAN",
    "PERCENTILE5",
    "PERCENTILE25",
    "PERCENTILE50",
    "PERCENTILE75",
    "PERCENTILE90",
    "PERCENTILE95",
    "RANK",
  ];

  if (samplestatic == null || samplestatic == "") {
    return ressampsat;
  } else if (lstsampstat.includes(samplestatic.toString().toUpperCase())) {
    ressampsat = samplestatic.toString();
    return ressampsat;
  } else {
    return "Error Invalid Input Sample Statistic";
  }
}
export function measurmentDateSearch(): MeasurmentDate {
  let sDate: any = new Date(0);
  let eDat: any = new Date(0);

  const lstMeasurmentdatesStorage: MeasurmentDate = getObjectFromStorage(ProfileSettings.DtMeasurement);

  if (lstMeasurmentdatesStorage != null) {
    sDate =
      lstMeasurmentdatesStorage.startDates[0] != null
        ? lstMeasurmentdatesStorage.startDates[lstMeasurmentdatesStorage.startDates.length - 1].date
        : new Date(0);
    eDat = lstMeasurmentdatesStorage.endDates[0] != null ? lstMeasurmentdatesStorage.endDates[0].date : new Date(0);

    const lstMeasurmentdates: MeasurmentDate = {
      startDates: isValidDate(sDate) !== new Date(0) ? sDate : new Date(0),
      endDates: isValidDate(eDat) !== new Date(0) ? eDat : new Date(0),
    };
    return lstMeasurmentdates;
  } else {
    const lstMeasurmentdates: MeasurmentDate = {
      startDates: sDate,
      endDates: new Date(0),
    };
    return lstMeasurmentdates;
  }
}

export function searchedDateInMeasurementDate(date: any, dateType: any): boolean {
  let drow: any = false;
  try {
    const lstMeasurmentdatesStorage: MeasurmentDate = getObjectFromStorage(ProfileSettings.DtMeasurement);
    if (dateType == "S")
      drow = lstMeasurmentdatesStorage.startDates.some((s) => Date.parse(s.date) === Date.parse(date));
    else if (dateType == "E")
      drow = lstMeasurmentdatesStorage.endDates.some((s) => Date.parse(s.date) === Date.parse(date));
  } catch (e) {
    return drow;
  }
  return drow;
}

export function bmuendquarterDate(): any {
  let dtendqtrdate: any = new Date(0);
  let drow: Date = null;
  const lstMeasurmentdatesStorage: MeasurmentDate = getObjectFromStorage(ProfileSettings.DtMeasurement);
  drow = lstMeasurmentdatesStorage.endDates[0].date;
  if (drow !== null) {
    dtendqtrdate = drow;
    return dtendqtrdate;
  } else {
    return dtendqtrdate;
  }
}

export function holdingParamValidation(param: any, type: any): any {
  let resvalue: any;
  switch (type) {
    case HoldingExclude.TotalInvested:
      resvalue =
        param == null || param == ""
          ? "FALSE"
          : param.toString().toUpperCase() == "TRUE"
          ? param.toString()
          : param.toString().toUpperCase() == "FALSE"
          ? param.toString()
          : "Invalid";
      break;
    case HoldingExclude.ReturnofCapital:
      resvalue =
        param == null || param == ""
          ? "FALSE"
          : param.toString().toUpperCase() == "TRUE"
          ? param.toString()
          : param.toString().toUpperCase() == "FALSE"
          ? param.toString()
          : "Invalid";
      break;
    case HoldingExclude.CostBasis:
      resvalue =
        param == null || param == ""
          ? "FALSE"
          : param.toString().toUpperCase() == "TRUE"
          ? param.toString()
          : param.toString().toUpperCase() == "FALSE"
          ? param.toString()
          : "Invalid";
      break;
    case HoldingExclude.Proceeds:
      resvalue =
        param == null || param == ""
          ? "FALSE"
          : param.toString().toUpperCase() == "TRUE"
          ? param.toString()
          : param.toString().toUpperCase() == "FALSE"
          ? param.toString()
          : "Invalid";
      break;
    case HoldingExclude.Valuation:
      resvalue =
        param == null || param == ""
          ? "FALSE"
          : param.toString().toUpperCase() == "TRUE"
          ? param.toString()
          : param.toString().toUpperCase() == "FALSE"
          ? param.toString()
          : "Invalid";
      break;
    case HoldingExclude.ValuationDate:
      resvalue =
        param == null || param == ""
          ? "FALSE".toUpperCase()
          : param.toString().toUpperCase() == "TRUE".toUpperCase()
          ? param.toString()
          : param.toString().toUpperCase() == "FALSE".toUpperCase()
          ? param.toString()
          : "Invalid";
      break;
    case HoldingExclude.TVPI:
      resvalue =
        param == null || param == ""
          ? "FALSE"
          : param.toString().toUpperCase() == "TRUE"
          ? param.toString()
          : param.toString().toUpperCase() == "FALSE"
          ? param.toString()
          : "Invalid";
      break;
    case HoldingExclude.RVPI:
      resvalue =
        param == null || param == ""
          ? "FALSE"
          : param.toString().toUpperCase() == "TRUE"
          ? param.toString()
          : param.toString().toUpperCase() == "FALSE"
          ? param.toString()
          : "Invalid";
      break;
    case HoldingExclude.DPI:
      resvalue =
        param == null || param == ""
          ? "FALSE"
          : param.toString().toUpperCase() == "TRUE"
          ? param.toString()
          : param.toString().toUpperCase() == "FALSE"
          ? param.toString()
          : "Invalid";
      break;
  }

  return resvalue;
}

export function validateReportedValuation(requirereportedvaluation: any): number {
  let result = 0;
  // eslint-disable-next-line no-undef, no-unused-vars
  const value = String(requirereportedvaluation);
  if (value.trim().toUpperCase() == "STARTDATE") {
    result = 1;
  } else if (value.trim().toUpperCase() == "ENDDATE") {
    result = 2;
  } else if (value.trim().toUpperCase() == "STARTANDENDDATE") {
    result = 3;
  } else if (value == null || value == "" || value == "null") {
    result = 0;
  } else {
    result = 10;
  }
  return result;
}
export function getWeightMethod(weightMethodValue: any): any {
  if (weightMethodValue == null || weightMethodValue == "") {
    return "CAPITALIZATION";
  }
  let wmResult: any = weightMethodValue.toString().toUpperCase();
  switch (wmResult) {
    case "CAPITALIZATION":
    case "EQUAL":
      break;
    case "EXCELDNA.INTEGRATION.EXCELMISSING":
      wmResult = "CAPITALIZATION";
      break;
    case "EXCELDNA.INTEGRATION.EXCELEMPTY":
      wmResult = "CAPITALIZATION";
      break;
    case "EXCELDNA.INTEGRATION.EXCELERROR":
      wmResult = "ErrorInvalid format for Weighting Method parameter";
      break;
    default:
      wmResult = "ErrorInvalid format for Weighting Method parameter";
      break;
  }
  return wmResult;
}
export function validateUAcurrencyParam(uaCurrency: any): string {
  if (uaCurrency == null || uaCurrency == "") {
    return "";
  } else if (uaCurrency.toString().toUpperCase() == "LOCAL") {
    return "Local";
  }
  const uacurrencyResult: any = getObjectFromStorage(ProfileSettings.DtCurrencies);
  uaCurrency = uacurrencyResult?.filter(
    (a: any) => a.code.toString().toUpperCase() == uaCurrency.toString().toUpperCase().trim()
  );
  if (uaCurrency != null && uaCurrency.length > 0) {
    return uaCurrency[0].toString() != null && uaCurrency[0].toString() != "" ? uaCurrency[0].code.toString() : "";
  } else {
    return "Invalid";
  }
}
export function GetIsBurgissManagedClient(indexId?: any): any {
  let isBurgissManaged: any = null;
  if (indexId != null && indexId != "" && (typeof indexId === "string" || typeof indexId === "number")) {
    const lstPmeIndex: any = getObjectFromStorage(ProfileSettings.LstPmeIndex);
    isBurgissManaged = lstPmeIndex.filter((e) => e.benchmarkID == String(indexId));
    isBurgissManaged =
      isBurgissManaged != null && isBurgissManaged.length > 0 ? isBurgissManaged[0].burgissManaged : null;
    if (isBurgissManaged != null) {
      isBurgissManaged = isBurgissManaged == true;
    }
  }
  return isBurgissManaged;
}
export function isValidPeerGroupIDRank(peerGroupID?: any): any {
  if (peerGroupID == null) {
    return "-1";
  } else {
    return peerGroupID.ToString();
  }
}
export function ValidateByWeight(argumentValue: any, filerparam: any = null) {
  let investmentValue: any;
  const sb = [];
  // const characters = [" ", ","];
  try {
    if ((argumentValue === null || argumentValue === "") && filerparam === "Weight") {
      investmentValue = "Error: Weight is Mandatory.";
    } else if (argumentValue.toString().toUpperCase() === "ALL") {
      investmentValue = argumentValue.toString();
    } else if (typeof argumentValue === "string") {
      if (
        (argumentValue.trim().toUpperCase() !== "FILTER" &&
          !argumentValue.includes(",") &&
          !/^\d+$/.test(argumentValue)) ||
        (filerparam === null && argumentValue === "")
      ) {
        investmentValue = argumentValue;
      } else if (filerparam === null && argumentValue !== "Filter") {
        investmentValue = argumentValue;
      } else if (
        filerparam !== "" &&
        argumentValue.toUpperCase() !== "FILTER" &&
        filerparam.toUpperCase() !== "WEIGHT"
      ) {
        investmentValue = "Error: Invalid format for weight parameter";
      } else if (argumentValue.toUpperCase() === "FILTER" && (filerparam === null || filerparam === "")) {
        investmentValue = "Error: Invalid format for weight parameter";
      } else if (filerparam !== "" && filerparam !== null && argumentValue.toUpperCase() === "FILTER") {
        investmentValue = "-1";
      } else if (!argumentValue.includes(",")) {
        investmentValue = parseInt(argumentValue, 10).toString();
      } else {
        investmentValue = argumentValue;
      }
    } else if (typeof argumentValue === "number") {
      if ((filerparam === null || filerparam === "") && argumentValue.toString().toUpperCase() !== "FILTER") {
        investmentValue = argumentValue.toString();
      } else if (filerparam !== "" && argumentValue.toString().toUpperCase() !== "FILTER") {
        investmentValue = argumentValue.toString();
      } else if (filerparam !== "" && filerparam !== null && argumentValue.toString().toUpperCase() === "FILTER") {
        investmentValue = "-1";
      }
    } else if (Array.isArray(argumentValue) && Array.isArray(argumentValue[0])) {
      const rows = argumentValue.length;
      const cols = argumentValue[0].length;

      for (let x = 0; x < rows; x++) {
        for (let y = 0; y < cols; y++) {
          sb.push(argumentValue[x][y] + ";");
        }
      }
      //investmentValue = sb.join('').trimEnd(characters.join('')).trimEnd(';');
      investmentValue = sb.join("");
      if (investmentValue === "") {
        investmentValue = "Error: Invalid format for weight parameter";
      }
    }
    return investmentValue;
  } catch (ex) {
    return "Error: Invalid format for weight parameter";
  }
}
export function ValidateByUniverse(argumentValue: any, filerparam: any = null) {
  const sb = [];
  // let characters = [" ", ","];
  let investmentValue: any;
  try {
    if (argumentValue === "" || argumentValue === null) {
      investmentValue = "Error: Invalid format for universe parameter";
    } else if (argumentValue.toString().toUpperCase() === "ALL") {
      investmentValue = argumentValue.toString();
    } else if (argumentValue instanceof Error) {
      investmentValue = "Error: Invalid format for universe parameter";
    } else if (typeof argumentValue === "string") {
      if (
        (argumentValue.trim().toUpperCase() !== "FILTER" &&
          !argumentValue.includes(",") &&
          !/^\d+$/.test(argumentValue)) ||
        (filerparam === null && argumentValue === "")
      ) {
        investmentValue = argumentValue.toString();
      } else if (filerparam === null && argumentValue !== "Filter" && argumentValue != "") {
        investmentValue = argumentValue;
      } else if (filerparam === undefined && argumentValue !== "Filter") {
        investmentValue = argumentValue;
      } else if (filerparam !== "" && argumentValue.toUpperCase() !== "FILTER") {
        investmentValue = "Error: Invalid format for universe parameter";
      } else if (argumentValue.toUpperCase() === "FILTER" && (filerparam === null || filerparam === undefined)) {
        investmentValue = "Error: Invalid format for universe parameter";
      } else if (filerparam !== "" && filerparam !== undefined && argumentValue.toUpperCase() === "FILTER") {
        investmentValue = "-1";
      } else {
        investmentValue = argumentValue.toString();
      }
    } else if (typeof argumentValue === "number") {
      if ((filerparam === undefined || filerparam === "") && argumentValue.toString().toUpperCase() !== "FILTER") {
        investmentValue = argumentValue.toString();
      } else if (filerparam !== "" && argumentValue.toString().toUpperCase() !== "FILTER") {
        investmentValue = argumentValue.toString();
      } else if (filerparam !== "" && filerparam !== undefined && argumentValue.toString().toUpperCase() === "FILTER") {
        investmentValue = "-1";
      }
    } else if (Array.isArray(argumentValue) && Array.isArray(argumentValue[0])) {
      const rows = argumentValue.length;
      const cols = argumentValue[0].length;

      for (let x = 0; x < rows; x++) {
        for (let y = 0; y < cols; y++) {
          sb.push(argumentValue[x][y] + ";");
        }
      }
      //  investmentValue = sb.join('').trimEnd(characters.join('')).trimEnd(';');
      investmentValue = sb.join("");

      if (investmentValue === "") {
        investmentValue = "Error: Invalid format for universe parameter";
      }
    }
    return investmentValue;
  } catch (ex) {
    return "Error: Invalid format for universe parameter";
  }
}
export function ValidateByCommitment(argumentValue: any, filerparam: any = null) {
  const sb = [];
  // let characters = [" ", ","];
  let invesmentValue = "";
  try {
    if (argumentValue === "" || argumentValue === null) {
      invesmentValue = "Error: Commitment is Mandatory.";
    } else if (argumentValue.toString().toUpperCase() === "ALL") {
      invesmentValue = argumentValue.toString();
    } else if (typeof argumentValue === "string") {
      if (
        (argumentValue.trim().toUpperCase() !== "FILTER" &&
          !argumentValue.includes(",") &&
          !!String(argumentValue)
            .split(";")
            .every((char) => /\d/.test(char))) ||
        (filerparam === null && argumentValue === "")
      ) {
        invesmentValue = argumentValue.toString();
      } else if (filerparam === null && argumentValue !== "Filter") {
        invesmentValue = argumentValue.toString();
      } else if (filerparam !== "" && argumentValue.toUpperCase() !== "FILTER") {
        invesmentValue = "Error: Invalid format for Commitment parameter";
      } else if (argumentValue.toUpperCase() === "FILTER" && (filerparam === null || filerparam === undefined)) {
        invesmentValue = "Error: Invalid format for Commitment parameter";
      } else if (filerparam !== "" && filerparam !== undefined && argumentValue.toUpperCase() === "FILTER") {
        invesmentValue = "-1";
      } else {
        invesmentValue = argumentValue.toString();
      }
    } else if (typeof argumentValue === "number") {
      if ((filerparam === undefined || filerparam === "") && argumentValue.toString().toUpperCase() !== "FILTER") {
        invesmentValue = argumentValue.toString();
      } else if (filerparam !== "" && argumentValue.toString().toUpperCase() !== "FILTER") {
        invesmentValue = argumentValue.toString();
      } else if (filerparam !== "" && filerparam !== undefined && argumentValue.toString().toUpperCase() === "FILTER") {
        invesmentValue = "-1";
      }
    } else if (Array.isArray(argumentValue) && argumentValue.length > 0 && Array.isArray(argumentValue[0])) {
      const rows = argumentValue.length;
      const cols = argumentValue[0].length;
      for (let x = 0; x < rows; x++) {
        for (let y = 0; y < cols; y++) {
          sb.push(argumentValue[x][y] + ";");
        }
      }

      //  invesmentValue = sb.join('').trimEnd(characters.join('')).trimEnd(';');
      invesmentValue = sb.join("").trimEnd();

      if (invesmentValue === "") {
        invesmentValue = "Error: Invalid format for Commitment parameter";
      }
    } else {
      invesmentValue = "Error: Invalid format for Commitment parameter";
    }
    return invesmentValue;
  } catch (ex) {
    return "Error: Invalid format for Commitment parameter";
  }
}
export function ChkvalidPercentRankValueUptoFourDecimal(paramValue: any, decimalcnt: number) {
  let result: any;
  try {
    if (paramValue === null || paramValue === "") {
      result = "Mandatory Required parameters not defined";
    } else if (typeof paramValue === "number") {
      const arr = paramValue.toString().split(".");
      if (arr.length >= 2 && arr[1].length > 4) {
        result = "Error Decimal";
      } else {
        const decimalBits = paramValue.toString() !== "" ? new Uint8Array(new Float64Array([paramValue]).buffer)[6] : 0;
        switch (decimalcnt) {
          case 4:
            result = decimalBits > 4 ? parseFloat(paramValue.toFixed(4)) : paramValue;
            break;
          case 2:
            result = decimalBits > 2 ? parseFloat(paramValue.toFixed(2)) : paramValue;
            break;
          default:
            result = paramValue;
        }
      }
    } else {
      result = "FormaterrorValue not supported";
    }
  } catch (ex) {
    result = "FormaterrorValue not supported";
  }
  return result;
}

export function ValidExcelDateToJSDate(dateString: any): any {
  return ExcelDateToJSDate(dateString);
}

export function CheckDate(dateValue: Date | null): boolean {
  if (dateValue == null) {
    return true;
  } else if (new Date(dateValue).getFullYear() == 1) {
    return false;
  } else if (new Date(dateValue).getFullYear() == 0) {
    return false;
  } else {
    return true;
  }
}
